(function() {
    console.log("Hello");
})();

var elem = document.querySelector('.main-carousel');
var flkty = new Flickity( elem, {
  // options
  cellAlign: 'left',
  contain: true,
  fade: true,
  wrapAround: false,
  pageDots: true,
  adaptiveHeight: true,
  draggable: true,
  prevNextButtons: false
});